module.exports = __webpack_public_path__ + "img/18a001-02.188b28e5.jpg";